module.exports = __webpack_public_path__ + "img/icon-list.208caa92.svg";